import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

export const useFindPsychiatristStyles = makeStyles<void, 'avatarContainer'>()((theme, _params, classes) => ({
  avatar: {
    borderRadius: '4px',
    color: 'rgba(0, 0, 0, 0.23)',
    display: 'block',
    height: '40px',
    width: '40px',
    '&.icon': {
      alignItems: 'center',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      display: 'flex',
      justifyContent: 'center',
      '& svg': {
        height: '24px',
        width: '24px',
      }
    },
  },
  avatarContainer: {
    alignItems: 'center',
    display: 'flex',
    height: '44px',
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    padding: '2px',
    width: '44px',
  },
  body: {
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(1),
    padding: theme.spacing(2, 3),
    [theme.breakpoints.up('sm')]: {
      margin: 0,
      padding: 0,
    }
  },
  confirmAvatar: {
    borderRadius: '4px',
    height: '128px',
    width: '128px'
  },
  dialogTitle: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  header: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up('sm')]: {
      padding: 0,
    }
  },
  emptyState: {
    [theme.breakpoints.up('sm')]: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '4px',
      marginTop: theme.spacing(5),
      padding: theme.spacing(3),
    }
  },
  providerBox: {
    alignItems: 'center',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    '&.active': {
      background: theme.palette.secondary.background,
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: '4px',
      [`& .${classes.avatarContainer}`]: {
        border: `1px solid ${theme.palette.secondary.main}`,
        borderRadius: '4px',
      }
    },
  },
  root: {
    background: grey[50],
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      background: theme.palette.common.white,
      padding: theme.spacing(13, 0, 12),
      width: '690px',
    },
  }
}));
